import { authHeaders, getRequest, invokeApi, postRequest } from '../components/network/apiclient';
import { gameLabelAssociationEndpoint, gameLabelsEndpoint } from './endpoint';

export const fetchGameLabels = (token, onSuccess, onError) =>
    invokeApi(getRequest(gameLabelsEndpoint.listPath(), authHeaders(token)), onSuccess, onError);

export const addGameLabel = (token, onSuccess, onError, labelName) =>
    invokeApi(postRequest(gameLabelsEndpoint.addPath(), authHeaders(token), { name: labelName }), onSuccess, onError);

export const deleteGameLabel = (token, onSuccess, onError, gameLabelId) =>
    invokeApi(postRequest(gameLabelsEndpoint.deletePath(), authHeaders(token), { gameLabelId }), onSuccess, onError);

export const renameGameLabel = (token, onSuccess, onError, gameLabelId, newLabelName) =>
    invokeApi(postRequest(gameLabelsEndpoint.renamePath(), authHeaders(token), { gameLabelId, newLabelName }), onSuccess, onError);

export const setGameLabels = (token, onSuccess, onError, favouriteGameId, gameLabelIds) =>
    invokeApi(postRequest(gameLabelAssociationEndpoint.setLabels(), authHeaders(token), { favouriteGameId, gameLabelIds }), onSuccess, onError);
